import React from 'react'
import { motion } from 'framer-motion'
import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme()

  return (
    <motion.button
      onClick={toggleTheme}
      className="relative p-3 rounded-xl bg-white/10 hover:bg-white/20 transition-all duration-300 group"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <motion.div
        className="relative w-6 h-6"
        animate={{ rotate: theme === 'dark' ? 180 : 0 }}
        transition={{ duration: 0.3 }}
      >
        {theme === 'light' ? (
          <Sun 
            className="w-6 h-6" 
            style={{ color: 'var(--primary)' }}
          />
        ) : (
          <Moon 
            className="w-6 h-6" 
            style={{ color: 'var(--primary)' }}
          />
        )}
      </motion.div>
      
      {/* Tooltip */}
      <div 
        className="absolute -top-12 left-1/2 transform -translate-x-1/2 text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap"
        style={{
          backgroundColor: 'var(--bg-card)',
          color: 'var(--text-primary)',
          border: '1px solid var(--border-primary)'
        }}
      >
        {theme === 'light' ? 'Modo Escuro' : 'Modo Claro'}
      </div>
    </motion.button>
  )
}

export default ThemeToggle
